<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Schenker
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De schenker is de persoon die vrijwillig een geldbedrag, goederen of rechten schenkt zonder
                tegenprestatie. De schenking moet daadwerkelijk en onvoorwaardelijk zijn.
                <div class="space20"></div>

                In principe hoeft de schenker geen aangifte te doen, tenzij hij optreedt namens de ontvanger of een
                notariële schenking laat opmaken. Wel is het belangrijk dat de schenker de ontvanger informeert over de
                hoogte van het bedrag, zodat deze correct aangifte kan doen.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading12">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse12" aria-expanded="false" aria-controls="collapse12">
                Is de klant 'Ontvanger', 'Schenker' of 'Aangever'?
            </button>
        </h2>
        <div id="collapse12" class="accordion-collapse collapse" aria-labelledby="heading12"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                In deze aangifte Schenkbelasting kun je er voor kiezen de klant in te vullen als 'Ontvanger' of als
                'Schenker'. In beide gevallen wordt de aangifte in het dossier van deze klant bewaard.
                <div class="space20"></div>
                De persoon die de schenking ontvangt (de ontvanger) is verplicht om aangifte schenkbelasting te doen.
                Dit geldt ook als er uiteindelijk geen belasting verschuldigd is, bijvoorbeeld bij toepassing van een
                vrijstelling. De aangifte kan digitaal worden ingediend via SnelStart Fiscaal.
                <div class="space20"></div>
                Bij een aangifte via SnelStart Fiscaal wordt de ontvanger als aangever in de aangifte vermeld.
            </div>
        </div>
    </div>


</div>
